import React from 'react'

const HeroPlayIcon = () => (
  <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_56_1829)">
      <path d="M1.50171 1.76013L12.3906 8.76013L1.50171 15.7601V1.76013Z" fill="#F6F6F6" stroke="#F6F6F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_56_1829">
        <rect width="14" height="17" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default HeroPlayIcon
